module.exports = __webpack_public_path__ + "img/Project-dashboard.867d4842.png";